import apiClient from '../axios';

export interface ApiResponse<T> {
  responseValue: T;
  statusCode: number;
  message: string;
}

export enum NotificationType {
  NewChatMessage = 3,
  ContractVoteTurn = 4,
  ContractAdded = 5,
  ContractVoteDelegated = 6,
  ContractRevision = 7,
  ContractApproved = 8,
  ContractRejected = 9,
}

export interface AppNotification {
  id: number;
  title: string;
  message: string;
  type: number;
  isRead: boolean;
  referenceId: string | null;
  createdDate: string;
}

export const notificationService = {
  async getAll(): Promise<ApiResponse<AppNotification[]>> {
    const response = await apiClient.get('/Notification/web');
    return response.data;
  },

  async getUnreadCount(): Promise<ApiResponse<number>> {
    const response = await apiClient.get('/Notification/web/unread-count');
    return response.data;
  },

  async markAsRead(id: number): Promise<ApiResponse<number>> {
    const response = await apiClient.patch(`/Notification/web/${id}/read`);
    return response.data;
  },

  async markAllAsRead(): Promise<void> {
    await apiClient.patch('/Notification/web/read-all');
  },
};

export default notificationService;
